import { FC, SVGProps } from 'react'
import theme from 'theme'
import { useThemeColors } from 'hooks/useThemeColors'

type Props = SVGProps<SVGSVGElement> & {
  sx?: Record<string, unknown>
}

const TrendsPerformanceIcon: FC<Props> = ({ ...props }) => {
  const getColor = useThemeColors()

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <mask id="path-1-inside-1_1170_2416" fill={theme.colors.white}>
        <path d="M1 6H16V9H1V6Z" />
      </mask>
      <path d="M1 9H16V3H1V9Z" fill={getColor('text-primary')} mask="url(#path-1-inside-1_1170_2416)" />
    </svg>
  )
}

export default TrendsPerformanceIcon
